import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormDto } from '../../../models/ortak.dtos';
import { DxButtonModule } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
// Dashboard Faz0 Clara: eski hâli — kullanılmayan IDE otomatik-importu (devexpress paketini boşuna çekiyordu)
// import {expression} from "devexpress-dashboard/model/data-item/metadata/_measure";
import { DynamicButton } from '../../../constants';

@Component({
  selector: 'dk-popup-header',
  standalone: true,
  imports: [CommonModule,DxButtonModule],
  templateUrl: './popup-header.component.html',
  styleUrls: ['./popup-header.component.scss'],
})
export class PopupHeaderComponent {
    @Input() isShowCancelButton = true;
    @Input() state: string;
    @Input() width: any;
    @Input() formMetada!: FormDto;
    @Input() visible: boolean = false;
    @Input() displayEditBtn: boolean = true;
    @Input() title: string = '';
    @Input() dynamicButtons: DynamicButton[] = [];
    @Input() maximizable = false;
    @Input() isFullScreen = false;
    @Output() isFullScreenChange = new EventEmitter<boolean>();
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() editModeChange = new EventEmitter<boolean>();
    @Output() dynamicButtonClicked = new EventEmitter<DynamicButton>();
    editViewIcon = 'edit';
    editViewHint = 'Düzenle';
    @Input() isAdmin = false
    @Input() editmode: boolean = false;
    duzenle:any='Düzenle'
    editButtonOptions = {
      hint: 'Edit',
      icon: 'eyeopen',
      stylingMode: 'outlined',
      onClick: () => {
        this.toggleEdit()
      },

    };

    constructor() {

    }

    toggleEdit() {
      if (this.formMetada?.formYetki.updateYn || this.isAdmin) {
        this.editmode = !this.editmode
        this.editViewIcon = this.editmode ? 'eyeopen' : 'edit'
        this.editModeChange.emit(this.editmode)
      } else {
        alert('Bu işlemi yapmaya yetkiniz yok!','Uyarı')
      }
    }

    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen
      this.isFullScreenChange.emit(this.isFullScreen)
    }

    closePopup() {
      this.visible = false
      this.visibleChange.emit(false);
      this.editmode = false;
      this.editModeChange.emit(this.editmode)
    }

     handleDynamicButtonClick(dynamicButton: DynamicButton) {
    if (!dynamicButton.disabled) this.dynamicButtonClicked.emit(dynamicButton)
    }

    trackByFn(index: number, item: any): any {
      return item.id; // Eğer her butonun benzersiz bir 'id'si varsa onu kullanın
    }



}
